import { Box, SxProps, Theme, Typography } from "@mui/material";
import XCard from "../../../../components/xCard/xCard";
import { PinIcon } from "../../../../shared/images/icons";
import { Check } from "react-feather";
import { textXS } from "../../../../shared/constants";
import colors from "../../../../shared/constants/color";
import type { QuestionItem } from "../../../interviewAssistant/InterviewAssistant";
import { useWiserTheme } from "../../../../hooks/useWiserTheme";
import {
  getQuestionListItemSx,
  getQuestionListTextColor,
} from "../../../../shared/theme/wiserThemeHelpers";
import { centeredContentSx, columnGap8Sx, iconCheckWrapSx } from "../../style";

interface IProps {
  questions: QuestionItem[] | null;
  onQuestionClick: (id: number) => void;
  sx?: SxProps<Theme>;
}

export const QuestionListCard = ({ questions, onQuestionClick, sx }: IProps) => {
  const { darkModeActive, tokens } = useWiserTheme();

  return (
    <XCard
      title="Mevcut Sorular"
      icon={<img src={PinIcon} />}
      style="neutral"
      sx={sx}
    >
      {!questions || questions.length === 0 ? (
        <Box sx={centeredContentSx}>
          <Typography
            sx={textXS(
              400,
              darkModeActive ? tokens.textMuted : colors.neutral.N500,
            )}
          >
            Mevcut sorular bulunamadı.
          </Typography>
        </Box>
      ) : (
        <Box sx={columnGap8Sx}>
          {questions.map((question, index) => (
            <Box
              key={question.id}
              sx={getQuestionListItemSx(darkModeActive, question.checked)}
              onClick={() => {
                onQuestionClick(question.id);
              }}
            >
              {question.checked && (
                <Box sx={iconCheckWrapSx}>
                  <Check
                    size={14}
                    color={colors.green.G400}
                    strokeWidth={3}
                  />
                </Box>
              )}

              <Typography
                sx={textXS(
                  400,
                  getQuestionListTextColor(darkModeActive, question.checked),
                )}
              >
                {index + 1}. {question.question}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </XCard>
  );
};
